/**
 * @Page APICV
 * @Description [APICV]수신자료관리 - 협력사 정보 연계 - [D1]검수합격 통보서
 **/
 import React, { useState, useEffect, useRef, useCallback  } from "react";
 import Ribbon from '@/components/organisms/Ribbon';
 import ContentXearch from '@/components/organisms/ContentXearch';
 import Content from '@/components/organisms/Content';
 import Grid from '@/components/grid/agGrid';
 import CustomAlert from "@/components/molecules/CustomAlert";
 import AlertDialog from '@/components/material-UI/AlertDialog';
 import * as Common from '@/utils/Common'; 
 import CommonUtil from '@/utils/CommonUtil'; 
 import UploadModal from "@/components/organisms/UploadModal";
 import Loading from "src/components/atoms/CustomLoading2";
  
 const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
 const CODES = require('@/config/commonCode.json');
 const Utils = new CommonUtil();

 
  function APICV() {
 
    const token = Common.getToken();
    const userId = Common.getToken("id");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const grdRntc14Main = useRef();
    const [gridApi, setGridApi] = useState(null);
    const ckVnt1 = Common.getCookie("ck_vnt1"+userId)===null||Common.getCookie("ck_vnt1"+userId)===""||Common.getCookie("ck_vnt1"+userId)==="undefined"?tVnt1:Common.getCookie("ck_vnt1"+userId); 
    let [loading, setLoading] = useState(false);
    
      const onGridReady  = (params) => {
        setGridApi(params);
    };
    const [idata, setData] = useState({
        kVnt1 : ckVnt1,
        kComp : tComp,
        // kDocd : "",
        kTotcnt : "",
        kVnt1Nm: "",
        kPlnt: "",          //공장
        kPtno: '', // 품번
        kCompNm : tComp==="EHMC"?"현대자동차(주)":"기아자동차(주)",
        kPageNum: 1,
        kPageTotal: 0,
        kStartDate: Common.getToday(), // 파트너 전송일(시작)
        kEndDate: Common.getToday(), // 파트너 전송일(종료)
        
        vnt1List : [],
        docdList: [],
        plntList : [],  //공장
    }); 
    
    const [message, setMessage] = React.useState( {
        openAlert : false,      
        severity : "success",   
        msg : ""                
    });
    const { openAlert, severity, msg } = message;
    const [uploadInfo, setUploadInfo] = useState({ vnt1: tVnt1, subDir: "DATA" });

    const [panded, setPanded] = React.useState(true);
    const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px)"});
    const [dlgMessage, setDlgMessage] = React.useState( {
        openDlg : false,    
        dlgTrans : "",      
        dlgMsg : ""         
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;
  
    let [searchApi, setSearchApi] = useState(false); 
    const [openUpload, setOpenUpload] = React.useState(false);

    const onClearApi = useCallback(async (e) => {
        setSearchApi(false);

    }, []);


    /**
     * 공통코드 조회 (조회조건)
     */
    const onSearchCommon = (para, name) => {
		let commonData = idata;

		const fetchData = async (para, name) => {
			let param = encodeURIComponent(para);
			const query = SERVER_URL + '/comcd/search?query=' + param;
			await fetch(query, { headers: { Authorization: token } })
				.then((resp) => resp.json())
				.then((data) => {
					if (data.success) {
						if (name === 'plntList') {
							if (data.data.length > 0) {
								commonData['kPlnt'] = data.data[0].comCode;
								commonData['kPlntNm'] = data.data[0].text;
							}
						}
						commonData[name] = data.data;
						setData({ ...commonData });
					}
				});
		};
		fetchData(para, name);
	};

    const onSearchCommon1 = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    { 
                    commonData[name] = data.data[0].text;
                    setData({...commonData});
                    }
                })
        }
        fetchData(para, name);   
    }

    useEffect( () => {
        
        //공통코드 (T1업체)
        onSearchCommon(`{"pgmid":"VNT1"}`, "vnt1List");
        //공통코드 (문서코드)
        // onSearchCommon(`{"pgmid":"WEEK_MATE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        onSearchCommon1(`{"pgmid":"WRCVAND","kVnt1":"${idata.kVnt1}"}`, "kVnt1Nm");
        onSearchCommon(`{"pgmid":"PLNT","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}", "kGubn":"VMI"}`, "plntList");
    }, []);

    /**
     * Control 변경 Event
     * @param {*} e 
     */
    const onChange = async (e) => {
        const { name, value, desc } = e.target;

        let newSearchs = idata; 
        let newUploadInfo = uploadInfo;
        newSearchs[name] = value;
        newSearchs[name+"Nm"] = desc;
        
        setData({ ...newSearchs });

        if (name === "kVnt1")  {
            // newSearchs["kDocd"] = "";
            newSearchs["kPageNum"] = 1;
            newUploadInfo["vnt1"] = value;

            setData({ ...newSearchs });
            setUploadInfo({ ...newUploadInfo });

            onSearchCommon(`{"pgmid":"CONS_SALE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        }
        if(name==="kComp"){
            newSearchs["kCompNm"] = value==="EHMC"?"현대자동차(주)":"기아자동차(주)";
            // newSearchs["kDocd"] = "";
            setData({ ...newSearchs });

            onSearchCommon(`{"pgmid":"CONS_SALE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        }
        
        // onSearch()
    }

    /**
     * Grid Event 
     * @param {*} e 
     */
    const grdRntc14Main_onCellValueChanged = async (e) => {
    }
    const grdRntc14Main_onRowClicked = async (e) => {
    }

    /**
     * 검색조건
     */
    const optionsX = {
        0: [
        //T1업체
            {
                "formatter": "select", "name": "kVnt1", "labelName": "1차업체", "type": "text", "defaultValue": idata.kVnt1,  
                "codeMode": true,
                "selectAll": "",
                "codes": null,
                "comms": idata.vnt1List,
                "align": "left", 
            }, 
            {
				formatter: 'select',
				name: 'kPlnt',
				labelName: '공장',
				type: 'text',
				defaultValue: idata.kPlnt,
				codeMode: false,
				selectAll: '',
                codes: null,
                align: 'right',
				comms: idata.plntList,
			},
           
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
        ],
        1: [
          
            {
                "formatter": "input", "name": "kStartDate", "labelName": "장부재고일", "type": "date", "desc": "", "readOnly" : false,
                "defaultValue": idata.kStartDate,  
                "align": "left", 
                "labelType": "none" 
            }, 
            { "formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" }
        ]
    }

    /**
     * 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch = async (e) => {

        //T1업체선택 Check
        if (idata.kVnt1 == "")
        {
            setMessage({ openAlert : true, 
                        severity : "info",
                        msg : "1차업체를 선택하십시요 !"});
            document.getElementById("kVnt1").focus();                         
            return ;
        }

        //회사구분선택 Check
        if (idata.kComp == "")
        {
            setMessage({ openAlert : true, 
                         severity : "info",
                         msg : "회사구분을 선택하십시요 !"});
            document.getElementById("kComp").focus();                         
            return ;
        }

        // Cookie 값 셋팅
        Common.setCookie("ck_vnt1"+userId,idata.kVnt1,1);

        const page = "INF_DAIL_INSP_INFO"
        //"docd": "${idata.kDocd}"
        let para = `{
                        "kGubn":"${page}","plnt":"${idata.kPlnt}", "kStartDate":"${idata.kStartDate}",
                        "kVnt1": "${idata.kVnt1}", "kComp": "${idata.kComp}","kPtno":"${idata.kPtno}",
                        "kPageNum":"${idata.kPageNum}"
                    }`;
        let param = encodeURI(para);
        const query = SERVER_URL + "/AutoReceiver/PaidConsignedInventory/search?query=" + param;
        setSearchApi(query);
    }

    /**
    * 파일생성
    * @param {*} e 
    */
    const onUpload = async (e) => {
        let newSearchs = idata; 

        newSearchs["vnt1"] = idata.kWrcVand;
        setData({ ...newSearchs });

        setOpenUpload(true);
    }

    const handleUploadClickOpen = () => {

    setOpenUpload(true);
    };

    const handleUploadClose = () => {
    setOpenUpload(false);

    };

    /**
     * 엑셀
     * @param {*} e 
     */
    const onExcel = async (e) => {
        const page = "PAID_CONS"
        let para = `{"kDocument":"유상사급 재고 실사대상 리스트",
                     "kGubn":"${page}","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}",
                     "kStartDate":"${idata.kStartDate}",
                     "plnt" : "${idata.kPlnt}",
                     "vnt1Nm":"${idata.kVnt1Nm}","compNm":"${idata.kCompNm}"}`;
        
        let param = encodeURIComponent(para);
        const query = SERVER_URL + "/AutoReceiver/excel?query=" + param;
        setLoading(true);
        await fetch(query, {headers: {Authorization: token } })
            .then((resp) =>{
                return resp.blob();
            }).then((blob)=>{
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', '유상사급 재고 실사대상 리스트.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'error', err });
            })
        setLoading(false);

        // 엑셀파일 생성 메세지
        setMessage({ openAlert : true, 
                    severity : "success",
                    msg : "엑셀파일이 생성되었습니다."});
        
    }
    
    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});

        //DialogResult
        if (e.result == "N") return;

        //Transaction 구분
        switch (e.Trans) 
        {
            //등록
            case "I" :
                break;
            //수정
            case "U" :
                break;
            //삭제
            case "D" :
                break;

            case "D3" :
                break;
        }
    }
        
    //조회건수
    const onSetCount = (e) => {
        let cnt;
        if(gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay.length > 0){
            cnt = gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay[0].data.cnt;
        }else{
            cnt = 0;
        }
        let newSearchs = idata; 

        if(idata.kPageNum === 1){
            newSearchs["kPageTotal"] = Math.ceil(parseInt(cnt)/500);
            newSearchs["kTotcnt"] = Common.getNumberFormatter(cnt);
            setData({ ...newSearchs });
        }   
    }
        
    /**
     *Grid Column 정의 
    */
     const columnDefs = [
        { headerName: "재고 실사 입력 기한(From)", field: "E_DATAB", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true ,valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "재고 실사 입력 기한(To)", field: "E_DATBI", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true ,valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "품번", field: "MATNR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, valueGetter: Utils.partnoGetter, hide: false },
         { headerName: "자재 내역", field: "MAKTX", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true, hide: false },
        { headerName: "실물인수 후 미판매처리 수량", field: "ZLABST_W", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "업체재고", field: "ZLABST", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "총 업체재고", field: "ZLABST_ALL", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "Assy 재고", field: "ZLABST_A", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "Part 재고", field: "ZLABST_P", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "총 완성차 재고관리", field: "ZLABST_PHY", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "차이수량", field: "ZDIFF_QTY", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "생산투입수량(전월)", field: "ZPROD_QTY", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "불량/훼손품(전월)", field: "ZDAMAGE_QTY", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "기타(전월)", field: "ZOTHER_QTY", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "비고", field: "ZREMARK", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "상태", field: "STATUS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "상태명", field: "STATUS_NM", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false }
    ];

    const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                height :"calc(100vh - 65px - 35px - 50px - 21px - 8px)"
            });
        }else{
            setStyle({
                height :"calc(100vh - 65px - 35px - 50px - 21px - 101px - 8px)"
            });
        }
    }
    return(
        <>
            <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />

            <UploadModal
                open={openUpload}
                onClose={handleUploadClose} 
                onClickOpen={handleUploadClickOpen}
                title={"CSV 업로드"}
                fileId={"APICV"}
                filePath={"C:\\HKC\\VAN\\APICV.CSV"}
                uploadInfo={uploadInfo}
                accp=".csv"
                maxFiles={1}
                validatorName={"csv"}
                uploadApi={SERVER_URL + "/erp/upload1"}
                data={idata.vnt1List}
            />
            <Loading loading={loading} />

            <Ribbon
                onInfoManual={false}
                onSearch={onSearch} onSearchName={null} //조회
                //onExcel={onExcel} onExcelName ={null}   //Excel
                // onUpload={onUpload} onUploadName={"생성"}//생성 
                onExcel={onExcel} onExcelName ={null}   //Excel
            >
                {"수신자료관리 > 협력사 정보 연계 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>유상사급 재고 실사대상 리스트</b>
            </Ribbon>


            <ContentXearch
                optionsX={optionsX}
                onChange={onChange}
                onClick={onClick} />


            <Content style={style}> 
                <div className={"grid_type01"} >
                    <div className={"grid_wrap01"}> 
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={grdRntc14Main}
                                gridId={"APICV"}                 
                                columnDefs={columnDefs}           
                                pagination={true}                 
                                paginationCsv={false}             
                                onGridReadyEvent={onGridReady}
                                paginationPageSize={"500"}        
                                rowMultiSelectWithClick={true}    
                                suppressRowClickSelection={true}  
                                rowSelection={"multiple"}         
                                enableRangeSelection={false}      
                                enableCellTextSelection={true}    
                                isFirst={false}                   
                                displayNo = {false}
                                searchApi={searchApi} 
                                onClearApi={()=> {onSetCount();onClearApi()}}
                                onCellValueChangedEvent={grdRntc14Main_onCellValueChanged}
                                onRowClickEvent={grdRntc14Main_onRowClicked}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
  }
  export default APICV;